import cn from 'classnames';
import type { ReactNode } from 'react';

import './radio-card-group.scss';

type RadioCardGroupProps = Readonly<{
    children: ReactNode;
    className?: string;
    testId?: string;
    name?: string;
}>;

export const RadioCardGroup = ({ children, className, testId, name }: RadioCardGroupProps) => {
    return (
        <fieldset className={cn('radio-card-group', className)} data-testid={testId} data-name={name}>
            {children}
        </fieldset>
    );
};
